@if (labels$ | async; as labels) {
    <adapt-select-label [labels]="labels"
                        (labelsChange)="onLabelsChanged($event, labels)"></adapt-select-label>
}
